import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Home from "../pages/customers/authenticated/Home";
import ContactGroup from "../pages/customers/authenticated/ContactGroup";
import ContactUpload from "../pages/customers/authenticated/ContactUpload";
import ContactGroupManagement from "../pages/customers/authenticated/ContactGroupManagement";
import Profile from "../pages/customers/authenticated/Profile";
import Senders from "../pages/customers/authenticated/senderIdManagement/Senders";
import QuickSms from "../pages/customers/authenticated/QuickSms";
import BulkSms from "../pages/customers/authenticated/BulkSms";
import SubscriptionPlans from "../pages/customers/authenticated/SubscriptionPlans";
import PaymentProcessing from "../components/subscription/PaymentProcessing";
import PaymentSuccess from "../components/subscription/PaymentSuccess";
// import PaymentFailed from "../components/subscription/PaymentFailed";
import PaymentVerification from "../pages/customers/authenticated/PaymentVerification";
import ApiKey from "../pages/customers/authenticated/senderIdManagement/ApiKey";
import ApiDocumentation from "../components/ApiDocumentationPage/ApiDocumentation";
import ContactUs from "../pages/customers/authenticated/ContactUs";
import MessageReports from "../components/navigation/MessageReports";
import PaymentHistory from ".././pages/customers/authenticated/PaymentHistory";
import ScheduledMessages from "../components/navigation/ScheduledMessages";
import Birthdays from "../components/navigation/Birthdays";

const AuthRoutes = () => {
  const { txtconnect_ng_user, isVerified } = useSelector((state) => state.user);
  if (!txtconnect_ng_user) {
    return <Navigate to="/login" replace />;
  }
  if (txtconnect_ng_user && !isVerified) {
    return <Navigate to="/verify-otp" replace />;
  }

  return (
    <Routes>
      <Route path="/home" element={<Home />} />
      <Route path="/contacts" element={<ContactGroup />} />
      <Route path="/contacts/upload" element={<ContactUpload />} />
      <Route path="/contacts/manage/:groupSlug" element={<ContactGroupManagement />} />
      <Route path="/contact-group" element={<ContactGroup />} />
      <Route path="/quick-sms" element={<QuickSms />} />
      <Route path="/bulk-sms" element={<BulkSms />} />
      <Route path="/subscription-plans" element={<SubscriptionPlans/>} />
      <Route path="/payment/processing" element={<PaymentProcessing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/failed" element={<PaymentSuccess />} />
      <Route path="/payment-verification" element={<PaymentVerification />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/senders" element={<Senders />} />
      <Route path="/api-key" element={<ApiKey />} />
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
      <Route path="/ApiDocumentation" element={<ApiDocumentation />} />
      <Route path="/contact-us" element={<ContactUs />} />

      <Route path="/message-reports" element={<MessageReports />} />
      <Route path="/payment-history" element={<PaymentHistory />} />
      <Route path="/scheduled-messages"element={<ScheduledMessages/>}/>
      <Route path="/birthdays" element={<Birthdays/>}/>
    </Routes>
  );
};

export default AuthRoutes;
